import React from 'react';
import * as helpers from "../../utils/utils.js"
import "./navBar.css"

function NavBar({step, setStep, disabled, actionLabel, onAction, actionClassName = ""}) {
    const steps = ["selections", "info", "payment"]
    const handleClick = () => {
        if (onAction) {
            onAction();
            return;
        }

        setStep(step+1);
    };

    return (
        <div className='nav-bar'>
            <button
                disabled={disabled()}
                onClick={handleClick}
                className={`btn ${actionClassName}`}
                id='continue-btn'
            >
                {actionLabel || `Continue to ${helpers.capitalizeFirstLetter(steps[step+1])}`}
            </button>
        </div>
    );
};

export default NavBar;
